import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { LinkButtonDataProps } from '../../../../utils';
import { componentConfigThemeKey, MenuLinkThemeProps } from './MenuLink';
import { useTheme } from '../../../../../../../theming/useTheme';
import {
  getFontSizesBySemanticTag,
  getStyleBySize,
} from '../../../../../../../typography/semanticTags/semanticTags.utils';
import { MEDIA_BREAKPOINTS } from '../../../../../../../mediaQueries.const';

const createStyle = (baseUnit: number, linkColor: string) => StyleSheet.create({
  button: {
    color: linkColor,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit}px`,
    },
  },
});

export const MenuButton: React.FunctionComponent<LinkButtonDataProps> = props => {
  const { onClick, text } = props;
  /* eslint-disable-next-line no-new-func */
  const onClickFunction = new Function(onClick);
  const { idleColor, baseUnit, fontSizesStyles } = useTheme<MenuLinkThemeProps>(componentConfigThemeKey);
  const style = createStyle(baseUnit, idleColor);
  const styleByFontSize = getStyleBySize(fontSizesStyles, getFontSizesBySemanticTag('h4'));
  return (
    <button className={css(style.button, styleByFontSize)} type="button" onClick={() => onClickFunction()}>{text}</button>
  );
};
